import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
export const EyeIcon = ({
    showPassword,
    showPasswordVisibility,
    hidePasswordVisibility,
    position,
    right,
    top,
    transform
}) => {
    console.log("eye icon");
    
    return (showPassword ? <VisibilityIcon sx={{ marginLeft: "0px", cursor: "pointer", position:position, right:right, top:top, transform:transform }} onClick={hidePasswordVisibility} /> : <VisibilityOffIcon sx={{ marginLeft: "0px", cursor: "pointer", position:position, right:right, top:top, transform:transform }} onClick={showPasswordVisibility} />)
}